<template>
  <ion-page>
    <master-layout pageTitle="سود فروش محصول">
      <ion-card>
        <ion-card-content>
          <DataTable :headers="headers" :route="route"></DataTable>
          <div class="between">
            <div></div>
            <div>
              جمع سود :
              <money :number="p_benefit"></money>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Money from '/src/components/Money'

export default {
  data()
  {
    return {
      id: null,
      p_benefit : 0,
      route:'productProfit/ListAjax',
      headers: [
        'محصول',
        'ویژگی',
        'تعداد',
        'جمع',
        'سود'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  methods: {
    ...mapActions("app", {
      getIncomeReportItems: 'getIncomeReportItems',
    }),
  },
  async mounted()
  {
    const check = await this.getIncomeReportItems()
    if (check && check.ok)
    {
      this.p_benefit = check.p_benefit;
    }
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage,Money
  },
  watch: {
    $route()
    {
      if (this.$route.fullPath.indexOf('OilOrder/ListAjax') >= 0)
      {
        this.route = 'OilOrder/ListAjax?t='+(new Date().getTime())
      }
    }
  }
};
</script>

<style scoped>
.between
{
  display: flex;
  justify-content: space-between;
}
</style>